// Espelha shared/auth/permission.enum.ts. Apenas os códigos usados pela navbar
// e pela sidebar (gating de itens do menu); os demais nem existem neste enum.
export enum Permission {
  AGENDAMENTO_PROPRIO_READ = '126_R',

  AREA_COMUM_CREATE = '109_C',
  AREA_COMUM_READ = '109_R',
  AREA_COMUM_UPDATE = '109_U',

  CAMERA_READ = '113_R',

  CATEGORIA_CHAMADO_READ = '123_R',

  CHAMADO_READ = '122_R',
  CHAMADO_UPDATE = '122_U',

  CHAVE_VIRTUAL_READ = '311048_R',

  CONFIGURACOES_CREATE = '100_C',
  CONFIGURACOES_READ = '100_R',
  CONFIGURACOES_UPDATE = '100_U',

  CONFIGURAR_CAMERA_CREATE = '101_C',
  CONFIGURAR_CAMERA_READ = '101_R',

  CONFIGURAR_PSIM_CREATE = '103_C',
  CONFIGURAR_PSIM_READ = '103_R',

  CONTA_CREATE = '3_C',
  CONTA_READ = '3_R',

  CONVITE_VIRTUAL_READ = '310921_R',

  CORRESPONDENCIA_CREATE = '120_C',
  CORRESPONDENCIA_READ = '120_R',

  DISPOSITIVO_READ = '117_R',

  DOCUMENTO_READ = '132_R',

  ENQUETE_READ = '135_R',

  ENTREGA_AUTONOMA_READ = '141_R',

  EQUIPAMENTO_PAC_READ = '161108_R',

  ESTACIONAMENTO_READ = '111_R',

  EVENTO_READ = '114_R',

  FORNECEDORES_READ = '138_R',

  GRUPO_READ = '105_R',

  INQUILINO_READ = '142_R',

  INTEGRADOR_CREATE = '2_C',
  INTEGRADOR_READ = '2_R',

  INTEGRADOR_RECADO_READ = '144_R',

  MANUTENCAO_PREVENTIVA_READ = '137_R',

  PESSOA_CREATE = '106_C',
  PESSOA_READ = '106_R',

  PORTARIA_READ = '124_R',

  PREVISAO_VISITA_CREATE = '125_C',
  PREVISAO_VISITA_READ = '125_R',

  RECADO_READ = '121_R',

  RELATORIO_ABERTURA_PORTA = '133_C',
  RELATORIO_PRIMEIRO_ACESSO_CREATE = '130_C',
  RELATORIO_REGISTRO_CHAMADA = '131_C',
  RELATORIO_UNIDADE = '134_C',
  RELATORIO_VEICULO_READ = '140_R',

  UNIDADE_READ = '110_R',

  ASSEMBLEIA_READ = '136_R',

  ZELADOR_IA_READ = '141843_R',
}

// authorities vem do payload de um JWT (parte 2, index 1), que usa base64url
// (alfabeto com "-"/"_" e sem padding). atob espera base64 padrão, por isso a
// normalização abaixo antes de decodificar.
function decodeBase64Url(segment: string): string {
  const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padding = (4 - (base64.length % 4)) % 4;
  return atob(base64 + '='.repeat(padding));
}

function splitPermission(value: string): [string, string] | null {
  if (!value) {
    return null;
  }
  const parts = value.split('_');
  return parts.length >= 2 ? [parts[0], parts[1]] : null;
}

/** authorities do payload do access_token; [] em qualquer falha (nunca lança). */
export function decodeAuthorities(accessToken: string | null): string[] {
  try {
    if (!accessToken) {
      return [];
    }
    const payload = accessToken.split('.')[1];
    if (!payload) {
      return [];
    }
    const parsed = JSON.parse(decodeBase64Url(payload)) as { authorities?: unknown };
    return Array.isArray(parsed.authorities) ? (parsed.authorities as string[]) : [];
  } catch {
    return [];
  }
}

/** Espelha hasPerm do Angular: casa o id da permissão e checa se a ação bate. */
export function hasPerm(perm: Permission, authorities: readonly string[]): boolean {
  if (!authorities?.length) {
    return false;
  }
  const checkPermission = splitPermission(perm);
  if (!checkPermission) {
    return false;
  }
  const [id, action] = checkPermission;

  // Mesma regra do Angular: casa pelo primeiro id encontrado, não pelo mais permissivo.
  for (const authority of authorities) {
    const item = splitPermission(authority);
    if (item?.[0] === id) {
      return item[1].includes(action);
    }
  }
  return false;
}
